import BSInfantCerealProduct from 'models/BSInfantCerealProduct'

export const packagingInitialState = {
  category: BSInfantCerealProduct.category,
  subCategory: BSInfantCerealProduct.subCategory,
  GrainType: BSInfantCerealProduct.GrainType,
  OtherGrainType: BSInfantCerealProduct.OtherGrainType,
  Iron: BSInfantCerealProduct.Iron,
  IronCertification: BSInfantCerealProduct.IronCertification,
  NoAdditionalIngredients: BSInfantCerealProduct.NoAdditionalIngredients,
  Size: BSInfantCerealProduct.Size,
  Organic: BSInfantCerealProduct.Organic,
}

export const grainTypeOptions = [
  {
    value: '',
    label: 'Grain Type',
    isDisabled: true,
  },
  { value: 'Barley', label: 'Barley' },
  { value: 'Mixed Grain', label: 'Mixed Grain' },
  { value: 'Multi-grain', label: 'Multi-grain' },
  { value: 'Oatmeal', label: 'Oatmeal' },
  { value: 'Rice', label: 'Rice' },
  { value: 'Whole Wheat', label: 'Whole Wheat' },
  { value: 'Other', label: 'Other' },
]

export const sizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '8 oz', label: '8 oz' },
  { value: '16 oz', label: '16 oz' },
]
